import { Component } from '@angular/core';
import { LocaleService } from 'angular-l10n';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    
    constructor(public locale: LocaleService) {

        if (this.locale.getAvailableLanguages().indexOf(navigator.language) > -1)
            this.locale.setCurrentLanguage(navigator.language);
        else
            this.locale.setCurrentLanguage('en');
    }
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/app/app.component.ts